// Assessment Blueprints - Define assessment types and their properties
export const assessmentTypes = {
  IA1: {
    id: 'ia1',
    name: 'IA 1',
    fullName: 'Internal Assessment 1',
    description: 'Diagnostic Test',
    weighting: 40, // Part of CA
    color: 'bg-blue-100',
    textColor: 'text-blue-700',
    borderColor: 'border-blue-300',
    icon: '📝',
    category: 'internal'
  },
  IA2: {
    id: 'ia2',
    name: 'IA 2',
    fullName: 'Internal Assessment 2',
    description: 'Project Work',
    weighting: 40, // Part of CA
    color: 'bg-purple-100',
    textColor: 'text-purple-700',
    borderColor: 'border-purple-300',
    icon: '📊',
    category: 'internal'
  },
  IA3: {
    id: 'ia3',
    name: 'IA 3',
    fullName: 'Internal Assessment 3',
    description: 'Topic Test',
    weighting: 40, // Part of CA
    color: 'bg-indigo-100',
    textColor: 'text-indigo-700',
    borderColor: 'border-indigo-300',
    icon: '📋',
    category: 'internal'
  },
  EXAM: {
    id: 'exam',
    name: 'EXAM',
    fullName: 'Final Examination',
    description: 'End of Term Exam',
    weighting: 60,
    color: 'bg-red-100',
    textColor: 'text-red-700',
    borderColor: 'border-red-300',
    icon: '📖',
    category: 'external'
  },
  QUIZ: {
    id: 'quiz',
    name: 'QUIZ',
    fullName: 'Class Quiz',
    description: 'Quick Assessment',
    weighting: 0, // Optional, not part of final grade
    color: 'bg-yellow-100',
    textColor: 'text-yellow-700',
    borderColor: 'border-yellow-300',
    icon: '❓',
    category: 'formative'
  },
  ASSIGNMENT: {
    id: 'assignment',
    name: 'ASSIGNMENT',
    fullName: 'Homework Assignment',
    description: 'Take-home work',
    weighting: 0, // Optional, not part of final grade
    color: 'bg-green-100',
    textColor: 'text-green-700',
    borderColor: 'border-green-300',
    icon: '📝',
    category: 'formative'
  },
  TEST: {
    id: 'test',
    name: 'TEST',
    fullName: 'Class Test',
    description: 'Unit/Topic Test',
    weighting: 40, // Part of CA
    color: 'bg-orange-100',
    textColor: 'text-orange-700',
    borderColor: 'border-orange-300',
    icon: '✍️',
    category: 'internal'
  },
  PROJECT: {
    id: 'project',
    name: 'PROJECT',
    fullName: 'Project Work',
    description: 'Extended project',
    weighting: 40, // Part of CA
    color: 'bg-teal-100',
    textColor: 'text-teal-700',
    borderColor: 'border-teal-300',
    icon: '🎯',
    category: 'internal'
  }
};

// Assessment categories
export const assessmentCategories = {
  internal: {
    name: 'Internal Assessment',
    description: 'Counts towards CA (40%)',
    color: 'bg-blue-50',
    weighting: 40
  },
  external: {
    name: 'External Assessment',
    description: 'Final Examination (60%)',
    color: 'bg-red-50',
    weighting: 60
  },
  formative: {
    name: 'Formative Assessment',
    description: 'For learning, not grading',
    color: 'bg-gray-50',
    weighting: 0
  }
};

// Get assessment type by ID
export const getAssessmentType = (typeId) => {
  const upperTypeId = typeId?.toUpperCase();
  return assessmentTypes[upperTypeId] || {
    id: 'unknown',
    name: 'ASSESSMENT',
    fullName: 'Assessment',
    description: 'General Assessment',
    weighting: 0,
    color: 'bg-gray-100',
    textColor: 'text-gray-700',
    borderColor: 'border-gray-300',
    icon: '📄',
    category: 'formative'
  };
};

// Get assessment type from title
export const getAssessmentTypeFromTitle = (title) => {
  const titleUpper = title.toUpperCase();
  
  if (titleUpper.includes('IA 1') || titleUpper.includes('DIAGNOSTIC')) {
    return assessmentTypes.IA1;
  } else if (titleUpper.includes('IA 2') || titleUpper.includes('PROJECT')) {
    return assessmentTypes.IA2;
  } else if (titleUpper.includes('IA 3') || titleUpper.includes('TOPIC TEST')) {
    return assessmentTypes.IA3;
  } else if (titleUpper.includes('EXAM') || titleUpper.includes('FINAL')) {
    return assessmentTypes.EXAM;
  } else if (titleUpper.includes('QUIZ')) {
    return assessmentTypes.QUIZ;
  } else if (titleUpper.includes('ASSIGNMENT')) {
    return assessmentTypes.ASSIGNMENT;
  } else if (titleUpper.includes('TEST')) {
    return assessmentTypes.TEST;
  }
  
  return getAssessmentType('unknown');
};

// Calculate if assessment counts towards final grade
export const countsTowardsFinalGrade = (assessmentType) => {
  return assessmentType.weighting > 0;
};

// Get CA assessments (those that count towards 40%)
export const getCAAssessments = () => {
  return Object.values(assessmentTypes).filter(
    type => type.category === 'internal' && type.weighting > 0
  );
};

// Get exam assessments (those that count towards 60%)
export const getExamAssessments = () => {
  return Object.values(assessmentTypes).filter(
    type => type.category === 'external' && type.weighting > 0
  );
};
